export const isValidNumber = (valueNumber) => {
  // Not using "!valueNumber" because 0 is a valid number
  if (
    valueNumber === null ||
    valueNumber === undefined ||
    typeof valueNumber === 'boolean'
  )
    return false;
  const currentValue = Number(valueNumber);
  return !isNaN(currentValue);
};

export const formatPrice = (rawPrice) => {
  if (!isValidNumber(rawPrice)) return null;
  const convertedPrice = rawPrice / 100;
  return convertedPrice.toFixed(2);
};
